import { ModuleRegistry } from "seneca-common/features/module/registry";

import { default as makeWrongAnswerModeSelectorsFactory } from "./makeWrongAnswerModeSelectors";

const moduleRegistry = ModuleRegistry.getInstance();

export function makeWrongAnswerModeSelectors(sectionId: string) {
  return makeWrongAnswerModeSelectorsFactory({
    moduleRegistry,
    sectionId
  });
}
